/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */

import { CaretRightOutlined } from "@ant-design/icons";
import { Collapse, message, Progress } from "antd";
import { useEffect, useState } from "react";
import Countdown from "react-countdown";
import Web3 from "web3";
import { formatNumber } from "../../../components/utils/FormatNumber";
import {
  formatDateSchedule,
  formatDateSchedule1,
  rendererCountDown,
  rendererCountDown1,
  renderTextTime,
} from "../utilsIDO";
import { apiLaunchPad } from "../../../api/apiLaunchPad";
import { useAccount, useSwitchChain } from "wagmi";
import { useContract } from "../../../components/utils/useContract";
import abiCommit from "../abi/abiCommit.json";
import abiClaim from "../abi/abiClaim.json";
import abiToken from "../abi/abiToken.json";
import abiVesting from "../abi/abiVesting.json";
import {
  formatFromWei,
  formatToWei,
} from "../../../components/utils/ConvertWei";
import { useNetworkState } from "../../../components/utils/useNetwork";
import SubmitSolanaModal from "./SubmitSolanaModal";

const COMMING = 1;
const OPEN = 2;
const END = 3;
const ADDRESS_ZERO = "0x0000000000000000000000000000000000000000";

const fillRPC = (network: any) => {
  switch (network) {
    case 56:
      return "https://bnb-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
    case 1:
      return "https://eth-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
    case 43114:
      return "https://avax-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
    case 8453:
      return "https://base-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
    case 137:
      return "https://polygon-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
    case 42161:
      return "https://arb-mainnet.g.alchemy.com/v2/Ndjy9ivH6B-gwhfwwrYPBj3a68Cat0RO";
      break;
  }
};

function renderStatus(status: any) {
  let text = status?.toLowerCase();
  switch (text) {
    case "claimed":
      return <span className="status-claimed">{status}</span>;
      break;
    case "unclaimed":
      return <span className="status-unclaimed">{status}</span>;
      break;
    case "refunded":
      return <span className="status-refunded">{status}</span>;
      break;
    case "locked":
      return <span className="status-locked">{status}</span>;
      break;

    default:
      <span className="">{status}</span>;
      break;
  }
  return status;
}

const ItemHeaderRound = ({ name, status, text }: any) => {
  const { address }: any = useAccount();
  return (
    <div className="header-round">
      <div className="round-name">{name}</div>
      <div className="wrap1">
        {address ? (
          <>
            {status ? (
              <div className="round-status green">You're whitelisted</div>
            ) : (
              <div className="round-status">You're not whitelisted</div>
            )}
          </>
        ) : (
          ""
        )}
        <div className="text-more"></div>
      </div>
    </div>
  );
};

const ItemContentRound = ({
  obj,
  launchpadDetail,
  isWhiteList,
  onSendData,
  onSendData1,
  showNetworkWarning,
}: any) => {
  const { address }: any = useAccount();
  const selectedNetworkIds: any = useNetworkState();
  const [statusPool, setStatusPool]: any = useState();
  const [loadingCommit, setLoadingCommit]: any = useState(false);
  const [loadingClaim, setLoadingClaim]: any = useState(false);
  const [loadingBonus, setLoadingBonus]: any = useState(false);
  const [loadingRefundAll, setLoadingRefundAll]: any = useState(false);
  const [loadingRefundPartical, setLoadingRefundPartical]: any =
    useState(false);
  const [loadingApprove, setLoadingApprove]: any = useState(false);
  const [isApprove, setIsApprove]: any = useState(false);
  const [amountApproved, setAmountApproved]: any = useState(0);
  const [actionApprove, setActionApprove]: any = useState(false);
  const [actionCommit, setActionCommit]: any = useState(false);
  const [totalCommitUser, setTotalCommitUser]: any = useState(0);
  const [actionClaim, setActionClaim]: any = useState(false);
  const [actionRf, setActionRf]: any = useState(false);
  const [isClaimed, setIsClaimed]: any = useState(false);
  const [amountClaimed, setAmountClaimed]: any = useState(0);
  const [amountClaimedChange, setAmountClaimedChange]: any = useState(0);
  const [isClaimedBonus, setIsClaimedBonus]: any = useState(0);
  const [amountClaimedBonus, setAmountClaimedBonus]: any = useState(0);
  const [objVestingClaim, setObjVestingClaim]: any = useState(null);
  const [objAllocation, setObjAllocation]: any = useState(null);
  const [objBonus, setObjBonus]: any = useState(null);
  const [objVestingClaimChange, setObjVestingClaimChange]: any = useState(null);
  const [userClaimAmount, setUserClaimAmount] = useState(0);
  const [userRefundAmount, setUserRefundAmount] = useState(0);
  const [userPartialRefundAmount, setUserPartialRefundAmount] = useState(0);
  const [amountRefundPartial, setAmountRefundPartial]: any = useState(0);
  const [amountRefundAll, setAmountRefundAll]: any = useState(0);
  const [isCheckVesting, setIsCheckVesting] = useState(0);
  const [objSchedule, setObjSchedule]: any = useState(null);
  const [objPartialRefund, setObjPartialRefund]: any = useState(null);
  const [objRefund, setObjRefund]: any = useState(null);

  const [decimalsRF, setDecimalsRF]: any = useState(18);
  const [symbolRF, setSymbolRF]: any = useState("");

  const [isClaimedChange, setIsClaimedChange]: any = useState(false);
  const [loadingClaimChange, setLoadingClaimChange]: any = useState(false);
  const [actionClaimChange, setActionClaimChange]: any = useState(false);

  const [amountCommit, setAmountCommit]: any = useState();
  const [amountCommitFormat, setAmountCommitFormat]: any = useState("");

  const web3Open = new Web3(
    fillRPC(launchpadDetail?.currency?.chain?.chain_id)
  );
  const web3 = new Web3(fillRPC(launchpadDetail?.token?.chain?.chain_id));
  let percent = (obj?.total_sold / obj?.total_raise) * 100;

  let curentTime = Date.now();
  let startTimeMs = new Date(obj?.start_time).getTime();
  let endTimeMs = new Date(obj?.end_time).getTime();

  const ContractCommit: any = useContract(obj?.ido_contract, abiCommit);

  const ContractToken: any = useContract(
    launchpadDetail?.currency?.address,
    abiToken
  );
  const ContractClaim: any = useContract(obj?.claim_contract, abiClaim);
  const ContractVesting: any = useContract(obj?.claim_contract, abiVesting);

  const ContractClaim_Network = new web3.eth.Contract(
    abiClaim,
    obj?.claim_contract
  );
  const ContractVesting_Network = new web3.eth.Contract(
    abiVesting,
    obj?.claim_contract
  );
  const ContractCommit_network = new web3Open.eth.Contract(
    abiCommit,
    obj?.ido_contract
  );

  const getStatusPool = () => {
    if (startTimeMs > curentTime) {
      setStatusPool(COMMING);
    } else if (curentTime >= startTimeMs && curentTime <= endTimeMs) {
      setStatusPool(OPEN);
    } else if (curentTime > endTimeMs) {
      setStatusPool(END);
    }
  };

  const [warning, setwarning]: any = useState("");
  const [warningMax, setwarningMax]: any = useState("");
  const [warningDecimal, setwarningDecimal]: any = useState("");

  const handleAmoutCommit = async (event: any) => {
    let rawInput = event.target.value.replace(/,/g, "");
    let newValue = rawInput.replace(/[^0-9.]/g, "");
    const partsRaw = newValue.split(".");
    if (partsRaw.length > 2) {
      setwarning("Invalid number format.");
      setwarningMax("");
      setwarningDecimal("");
      return;
    }
    if (partsRaw.length === 1) {
      if (partsRaw[0] === "0") {
      } else {
        partsRaw[0] = partsRaw[0].replace(/^0+/, "");
      }
    }
    newValue = partsRaw.join(".");

    if (Number(newValue) > Number(obj?.max_join) && newValue) {
      setwarningMax(`Max buy is ${obj?.max_join}`);
      setwarning("");
      setwarningDecimal("");
    } else {
      setwarningMax("");
    }
    if (Number(newValue) < Number(obj?.min_join) && newValue) {
      setwarning(`Min buy is ${obj?.min_join}`);
      setwarningDecimal("");
      setwarningMax("");
    } else {
      setwarning("");
    }
    const decimalParts = newValue?.split(".");
    if (decimalParts?.length > 2) {
      setwarningDecimal("Invalid amount");
      setwarning("");
      setwarningMax("");
    }
    if (
      decimalParts.length === 2 &&
      decimalParts[1].length > launchpadDetail?.currency?.decimals
    ) {
      setwarningDecimal(
        `Max ${launchpadDetail?.currency?.decimals} decimal places allowed.`
      );
      setwarning("");
      setwarningMax("");
      return;
    } else {
      setwarningDecimal("");
    }

    setAmountCommit(newValue);
    const parts = newValue.split(".");
    if (parts[0]) {
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    const formattedValue =
      parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
    setAmountCommitFormat(formattedValue);
  };

  const checkTotalCommitUser = async () => {
    try {
      await ContractCommit?.userAmount(obj?.id, address)
        .then((res: any) => {
          let temp = formatFromWei(res, launchpadDetail?.currency?.decimals);
          setTotalCommitUser(temp);
        })
        .catch((err: any) => {
          console.log("err234", err);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  const checkTotalCommitUserNoAddress = async () => {
    try {
      await ContractCommit_network.methods
        .userAmount(obj?.id, address)
        .call({ from: address })
        .then((res: any) => {
          let temp = formatFromWei(res, launchpadDetail?.currency?.decimals);
          setTotalCommitUser(temp);
        })
        .catch((err: any) => {
          console.log("errrrr", err);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (
      launchpadDetail?.currency?.chain?.chain_id ===
      launchpadDetail?.token?.chain?.chain_id
    ) {
      setDecimalsRF(launchpadDetail?.currency?.decimals);
      setSymbolRF(launchpadDetail?.currency?.symbol);
    } else {
      setDecimalsRF(launchpadDetail?.currency_rf?.decimals);
      setSymbolRF(launchpadDetail?.currency_rf?.symbol);
    }
  }, [launchpadDetail]);

  const getAmountApprove = async () => {
    try {
      await ContractToken?.allowance(address, obj?.ido_contract)
        .then((res: any) => {
          let amountTemp = formatFromWei(
            res,
            launchpadDetail?.currency?.decimals
          );
          setAmountApproved(Number(amountTemp));
        })
        .catch((err: any) => {
          console.log("err", err);
          setAmountApproved(0);
        });
    } catch (error) {
      console.log("error", error);
      setAmountApproved(0);
    }
  };

  const getDataPoolEnd = async () => {
    try {
      await apiLaunchPad
        .getVesting(obj?.id, address)
        .then((res: any) => {
          if (res?.data?.code === 200) {
            setObjAllocation(res?.data?.data?.allocation);
            setObjVestingClaim(res?.data?.data?.vesting);
            setObjBonus(res?.data?.data?.bonus);
            setObjRefund(res?.data?.data?.refund);
            setObjPartialRefund(res?.data?.data?.partial_refund);
            setObjSchedule(res?.data?.data?.vestings);
            setObjVestingClaimChange(res?.data?.data?.crf);
          } else {
            setObjAllocation(null);
            setObjVestingClaim(null);
            setObjBonus(null);
            setObjRefund(null);
            setObjPartialRefund(null);
            setObjSchedule(null);
            setObjVestingClaimChange(null);
          }
        })
        .catch((err: any) => {
          console.log("err", err);
          setObjAllocation(null);
          setObjVestingClaim(null);
          setObjBonus(null);
          setObjRefund(null);
          setObjPartialRefund(null);
          setObjSchedule(null);
          setObjVestingClaimChange(null);
        });
    } catch (error) {
      console.log("error", error);
      setObjAllocation(null);
      setObjVestingClaim(null);
      setObjBonus(null);
      setObjRefund(null);
      setObjPartialRefund(null);
      setObjSchedule(null);
      setObjVestingClaimChange(null);
    }
  };

  const getDataClaimFromSc = async () => {
    try {
      if (showNetworkWarning) {
        await ContractClaim_Network?.methods
          ?.claimInfos(objVestingClaim?.pool_id, objVestingClaim?.id)
          .call({ from: address })
          .then((res: any) => {
            if (res?.user !== ADDRESS_ZERO) {
              setIsClaimed(true);
            } else {
              setIsClaimed(false);
            }
          })
          .catch((err: any) => {
            setIsClaimed(false);
            console.log("err claimInfos", err);
          });
      } else {
        await ContractClaim?.claimInfos(
          objVestingClaim?.pool_id,
          objVestingClaim?.id
        )
          .then((res: any) => {
            if (res?.user !== ADDRESS_ZERO) {
              setIsClaimed(true);
            } else {
              setIsClaimed(false);
            }
          })
          .catch((err: any) => {
            setIsClaimed(false);
            console.log("err claimInfos", err);
          });
      }
    } catch (error) {
      setIsClaimed(false);
      console.log("error claimInfos", error);
    }
  };

  const getTotalClaimedFromSc = async () => {
    try {
      await ContractClaim?.userClaimAmount(objVestingClaim?.pool_id, address)
        .then((res: any) => {
          if (res) {
            setAmountClaimed(
              formatFromWei(res, launchpadDetail?.token?.decimals)
            );
          } else {
            setAmountClaimed(0);
          }
        })
        .catch((err: any) => {
          console.log("err------", err);
          setAmountClaimed(0);
        });
    } catch (error) {
      setAmountClaimed(0);
    }
  };

  const getTotalClaimedFromSc_network = async () => {
    try {
      await ContractClaim_Network?.methods
        ?.userClaimAmount(objVestingClaim?.pool_id, address)
        .call({ from: address })
        .then((res: any) => {
          if (res) {
            setAmountClaimed(
              formatFromWei(res, launchpadDetail?.token?.decimals)
            );
          } else {
            setAmountClaimed(0);
          }
        })
        .catch((err: any) => {
          console.log("err------123", err);
          setAmountClaimed(0);
        });
    } catch (error) {
      setAmountClaimed(0);
    }
  };

  const getTotalClaimedChangeFromSc = async () => {
    try {
      await ContractClaim?.userCRFAmount(
        objVestingClaimChange?.pool_id,
        address
      )
        .then((res: any) => {
          if (res) {
            setAmountClaimedChange(formatFromWei(res, decimalsRF));
          } else {
            setAmountClaimedChange(0);
          }
        })
        .catch((err: any) => {
          setAmountClaimedChange(0);
        });
    } catch (error) {
      setAmountClaimedChange(0);
    }
  };

  const getTotalClaimedChangeFromSc_network = async () => {
    try {
      await ContractClaim_Network?.methods
        ?.userCRFAmount(objVestingClaimChange?.pool_id, address)
        .call({ from: address })
        .then((res: any) => {
          if (res) {
            setAmountClaimedChange(formatFromWei(res, decimalsRF));
          } else {
            setAmountClaimedChange(0);
          }
        })
        .catch((err: any) => {
          setAmountClaimedChange(0);
        });
    } catch (error) {
      setAmountClaimedChange(0);
    }
  };

  useEffect(() => {
    if (showNetworkWarning) {
      if (
        address &&
        statusPool === END &&
        objVestingClaimChange &&
        JSON.stringify(objVestingClaimChange) !== JSON.stringify({})
      ) {
        getTotalClaimedChangeFromSc_network();
      } else {
        setIsClaimedChange(false);
        setAmountClaimedChange(0);
      }
    } else {
      if (
        address &&
        statusPool === END &&
        objVestingClaimChange &&
        JSON.stringify(objVestingClaimChange) !== JSON.stringify({})
      ) {
        getTotalClaimedChangeFromSc();
      } else {
        setIsClaimedChange(false);
        setAmountClaimedChange(0);
      }
    }
  }, [
    address,
    statusPool,
    showNetworkWarning,
    objVestingClaimChange,
    actionClaimChange,
  ]);

  useEffect(() => {
    if (showNetworkWarning) {
      if (
        address &&
        statusPool === END &&
        objVestingClaim &&
        JSON.stringify(objVestingClaim) !== JSON.stringify({})
      ) {
        getTotalClaimedFromSc_network();
      } else {
        setAmountClaimed(0);
      }
    } else {
      if (
        address &&
        statusPool === END &&
        objVestingClaim &&
        JSON.stringify(objVestingClaim) !== JSON.stringify({})
      ) {
        getTotalClaimedFromSc();
      } else {
        setAmountClaimed(0);
      }
    }
  }, [
    address,
    showNetworkWarning,
    statusPool,
    objVestingClaim,
    objVestingClaim?.pool_id,
    actionClaim,
  ]);

  useEffect(() => {
    if (
      address &&
      statusPool === END &&
      objVestingClaim &&
      JSON.stringify(objVestingClaim) !== JSON.stringify({})
    ) {
      getDataClaimFromSc();
    } else {
      setIsClaimed(false);
    }
  }, [
    address,
    statusPool,
    ContractClaim_Network,
    ContractClaim,
    objVestingClaim,
    objVestingClaim?.pool_id,
    actionClaim,
  ]);

  useEffect(() => {
    if (address && statusPool === END) {
      getDataPoolEnd();
    } else {
      setObjAllocation(null);
      setObjVestingClaim(null);
    }
  }, [address, actionClaim, actionClaimChange, actionRf, statusPool]);

  useEffect(() => {
    if (statusPool === OPEN) {
      onSendData(actionCommit);
    }
    if (statusPool === END) {
      onSendData(actionClaim);
      onSendData1(actionRf);
    }
  }, [actionCommit, actionClaim, actionRf, statusPool]);

  useEffect(() => {
    if (address && statusPool === OPEN && ContractToken) {
      if (launchpadDetail?.currency?.address !== ADDRESS_ZERO) {
        getAmountApprove();
      }
    }
  }, [address, launchpadDetail, ContractToken, statusPool, actionApprove]);

  useEffect(() => {
    if (amountCommit) {
      if (launchpadDetail?.currency?.address === ADDRESS_ZERO) {
        setIsApprove(true);
      } else {
        if (Number(amountCommit) > amountApproved) {
          setIsApprove(false);
        } else {
          setIsApprove(true);
        }
      }
    }
  }, [amountCommit, launchpadDetail, amountApproved]);

  useEffect(() => {
    getStatusPool();
  }, [obj]);

  useEffect(() => {
    if (showNetworkWarning) {
      if (address && ContractCommit_network) {
        checkTotalCommitUserNoAddress();
      }
    } else {
      if (
        address &&
        ContractCommit &&
        ContractCommit_network &&
        statusPool === OPEN
      ) {
        checkTotalCommitUser();
      } else if (statusPool === END) {
        checkTotalCommitUserNoAddress();
      }
    }
  }, [
    address,
    showNetworkWarning,
    ContractCommit,
    ContractCommit_network,
    selectedNetworkIds,
    statusPool,
    actionCommit,
  ]);

  const getDataClaimBonus = async () => {
    try {
      await ContractClaim?.bonusInfos(objBonus?.pool_id, objBonus?.id)
        .then((res: any) => {
          setIsClaimedBonus(Number(res?.amount));
          setAmountClaimedBonus(
            formatFromWei(res?.amount, launchpadDetail?.token?.decimals)
          );
        })
        .catch((err: any) => {
          setIsClaimedBonus(0);
          setAmountClaimedBonus(0);
        });
    } catch (error) {
      setIsClaimedBonus(0);
      setAmountClaimedBonus(0);
    }
  };
  const getDataClaimBonus_network = async () => {
    try {
      await ContractClaim_Network?.methods
        ?.bonusInfos(objBonus?.pool_id, objBonus?.id)
        .call({ from: address })
        .then((res: any) => {
          setIsClaimedBonus(Number(res?.amount));
          setAmountClaimedBonus(
            formatFromWei(res?.amount, launchpadDetail?.token?.decimals)
          );
        })
        .catch((err: any) => {
          setIsClaimedBonus(0);
          setAmountClaimedBonus(0);
        });
    } catch (error) {
      setIsClaimedBonus(0);
      setAmountClaimedBonus(0);
    }
  };

  useEffect(() => {
    if (showNetworkWarning) {
      if (address && objBonus && ContractClaim_Network) {
        getDataClaimBonus_network();
      } else {
        setIsClaimedBonus(0);
        setAmountClaimedBonus(0);
      }
    } else {
      if (address && objBonus && ContractClaim) {
        getDataClaimBonus();
      } else {
        setIsClaimedBonus(0);
        setAmountClaimedBonus(0);
      }
    }
  }, [
    objBonus,
    showNetworkWarning,
    ContractClaim_Network,
    ContractClaim,
    address,
  ]);

  const getDataCheckVesting = async () => {
    try {
      await ContractVesting?.userClaimStatus(obj?.id, address)
        .then((res: any) => {
          setIsCheckVesting(Number(res));
        })
        .catch((err: any) => {
          setIsCheckVesting(0);
        });
    } catch (error) {
      setIsCheckVesting(0);
    }
  };
  const getDataCheckVesting_network = async () => {
    try {
      await ContractVesting_Network?.methods
        ?.userClaimStatus(obj?.id, address)
        .call({ from: address })
        .then((res: any) => {
          setIsCheckVesting(Number(res));
        })
        .catch((err: any) => {
          setIsCheckVesting(0);
        });
    } catch (error) {
      setIsCheckVesting(0);
    }
  };

  useEffect(() => {
    if (showNetworkWarning) {
      if (address && ContractVesting_Network) {
        getDataCheckVesting_network();
      }
    } else {
      if (address && ContractVesting) {
        getDataCheckVesting();
      }
    }
  }, [address, showNetworkWarning, ContractVesting, ContractVesting_Network]);

  const getDataCheckRefund = async () => {
    try {
      if (showNetworkWarning) {
        await ContractClaim_Network?.methods
          ?.userPartialRefundAmount(obj?.id, address)
          .call({ from: address })
          .then((res: any) => {
            setUserPartialRefundAmount(Number(res));
            let temp = formatFromWei(res, decimalsRF);
            setAmountRefundPartial(temp);
          });

        await ContractClaim_Network?.methods
          ?.userClaimAmount(obj?.id, address)
          .call({ from: address })
          .then((res: any) => {
            setUserClaimAmount(Number(res));
          });
        await ContractClaim_Network?.methods
          ?.userRefundAmount(obj?.id, address)
          .call({ from: address })
          .then((res: any) => {
            setUserRefundAmount(Number(res));
            let temp = formatFromWei(res, decimalsRF);
            setAmountRefundAll(temp);
          });
      } else {
        await ContractClaim?.userPartialRefundAmount(obj?.id, address).then(
          (res: any) => {
            setUserPartialRefundAmount(Number(res));
            let temp = formatFromWei(res, decimalsRF);
            setAmountRefundPartial(temp);
          }
        );

        await ContractClaim?.userClaimAmount(obj?.id, address).then(
          (res: any) => {
            setUserClaimAmount(Number(res));
          }
        );
        await ContractClaim?.userRefundAmount(obj?.id, address).then(
          (res: any) => {
            setUserRefundAmount(Number(res));
            let temp = formatFromWei(res, decimalsRF);
            setAmountRefundAll(temp);
          }
        );
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (address && statusPool === END && obj?.id) {
      getDataCheckRefund();
    }
  }, [
    obj,
    showNetworkWarning,
    ContractClaim_Network,
    ContractClaim,
    address,
    statusPool,
  ]);

  //----------------------------------------------------
  const [isSendingTx, setIsSendingTx] = useState(false);
  useEffect(() => {
    const handleBeforeUnload = (e: any) => {
      if (isSendingTx) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    const handleKeyDown = (e: any) => {
      if (isSendingTx && (e.key === "F5" || (e.ctrlKey && e.key === "r"))) {
        e.preventDefault();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isSendingTx]);

  const handleApprove = async () => {
    try {
      setIsSendingTx(true);
      setLoadingApprove(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingApprove(false);
        return;
      }
      if (
        Number(amountCommit) < obj?.min_join ||
        Number(amountCommit) > obj?.max_join ||
        !amountCommit
      ) {
        message.error({
          type: "error",
          content: "Invalid Amount",
          className: "custom-class",
          duration: 2,
        });
        setLoadingApprove(false);
        return;
      }
      let amountInWei = formatToWei(
        amountCommit,
        launchpadDetail?.currency?.decimals
      );
      await ContractToken.approve(obj?.ido_contract, amountInWei)
        .then(async (res: any) => {
          if (res) {
            await res
              .wait()
              .then((res1: any) => {
                if (res1?.status === 1) {
                  setLoadingApprove(false);
                  setActionApprove(!actionApprove);
                  message.success({
                    type: "success",
                    content: "Approved Successfully",
                    className: "custom-class",
                    duration: 2,
                  });
                } else {
                  setLoadingApprove(false);
                  message.error({
                    type: "error",
                    content: "Approved Transaction Fail",
                    className: "custom-class",
                    duration: 2,
                  });
                }
              })
              .catch((err: any) => {
                console.log("err", err);
                setLoadingApprove(false);
                message.error({
                  type: "error",
                  content: err?.reason || err?.message || "Unknown Error",
                  className: "custom-class",
                  duration: 2,
                });
              });
          } else {
            console.log("no res");
            setLoadingApprove(false);
            message.error({
              type: "error",
              content: "Unknown Error(Txn Not Found)",
              className: "custom-class",
              duration: 2,
            });
          }
        })
        .catch((err: any) => {
          console.log("err", err);
          setLoadingApprove(false);
          message.error({
            type: "error",
            content: err?.reason || err?.message || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (err: any) {
      console.log("err", err);
      setLoadingApprove(false);
      message.error({
        type: "error",
        content: err?.reason || err?.message || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  async function handleCommit() {
    try {
      setIsSendingTx(true);
      setLoadingCommit(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingCommit(false);
        return;
      }
      if (
        Number(amountCommit) < obj?.min_join ||
        Number(amountCommit) > obj?.max_join ||
        !amountCommit
      ) {
        message.error({
          type: "error",
          content: "Invalid Amount",
          className: "custom-class",
          duration: 2,
        });
        setLoadingCommit(false);
        return;
      }
      let params = {
        address: address,
        amount: Number(amountCommit),
        pool_id: obj?.id,
      };
      await apiLaunchPad
        .requestCommit(params)
        .then(async (res: any) => {
          if (res?.data?.data) {
            let _id = res?.data?.data?.id;
            let _poolId = obj?.id;
            let _token = res?.data?.data?.token;
            let _amount = res?.data?.data?.commit_amount_string;
            let _minAmount = res?.data?.data?.min_amount_string;
            let _maxAmount = res?.data?.data?.max_amount_string;
            let _startTime = res?.data?.data?.start_time;
            let _endTime = res?.data?.data?.end_time;
            let _sig = res?.data?.data?.signature;

            if (launchpadDetail?.currency?.address === ADDRESS_ZERO) {
              await ContractCommit.commit(
                _id,
                _poolId,
                _token,
                _amount,
                _minAmount,
                _maxAmount,
                _startTime,
                _endTime,
                _sig,
                {
                  value: _amount,
                }
              )
                .then(async (res: any) => {
                  await res
                    .wait()
                    .then(async (resW: any) => {
                      if (resW?.status === 1) {
                        let paramsUpdate = {
                          txn: res?.hash,
                        };
                        await apiLaunchPad.updateHashCommit(paramsUpdate, _id);
                        setLoadingCommit(false);
                        setActionCommit(!actionCommit);

                        setAmountCommit(0);
                        setAmountCommitFormat("");
                        setwarningDecimal("");
                        setwarning("");
                        setwarningMax("");
                        message.success({
                          type: "success",
                          content: "Committed Successfully",
                          className: "custom-class",
                          duration: 2,
                        });
                      } else {
                        setLoadingCommit(false);
                        message.error({
                          type: "error",
                          content: "Commit Fail, Status hash fail",
                          className: "custom-class",
                          duration: 2,
                        });
                      }
                    })
                    .catch((errW: any) => {
                      console.log("errW", errW);
                      setLoadingCommit(false);
                      message.error({
                        type: "error",
                        content:
                          errW?.reason ||
                          errW?.message ||
                          errW ||
                          "Unknown Error",
                        className: "custom-class",
                        duration: 2,
                      });
                    });
                })
                .catch((err: any) => {
                  console.log("err", err);
                  setLoadingCommit(false);
                  message.error({
                    type: "error",
                    content:
                      err?.reason || err?.message || err || "Unknown Error",
                    className: "custom-class",
                    duration: 2,
                  });
                });
            } else {
              await ContractCommit.commit(
                _id,
                _poolId,
                _token,
                _amount,
                _minAmount,
                _maxAmount,
                _startTime,
                _endTime,
                _sig
              )
                .then(async (res: any) => {
                  await res
                    .wait()
                    .then(async (resW: any) => {
                      if (resW?.status === 1) {
                        let paramsUpdate = {
                          txn: res?.hash,
                        };
                        await apiLaunchPad.updateHashCommit(paramsUpdate, _id);
                        setLoadingCommit(false);
                        setActionCommit(!actionCommit);

                        setAmountCommit(0);
                        setAmountCommitFormat("");
                        setwarningDecimal("");
                        setwarning("");
                        setwarningMax("");
                        message.success({
                          type: "success",
                          content: "Committed Successfully",
                          className: "custom-class",
                          duration: 2,
                        });
                      } else {
                        setLoadingCommit(false);
                        message.error({
                          type: "error",
                          content: "Commit Fail, Status hash fail",
                          className: "custom-class",
                          duration: 2,
                        });
                      }
                    })
                    .catch((errW: any) => {
                      console.log("errW", errW);
                      setLoadingCommit(false);
                      message.error({
                        type: "error",
                        content:
                          errW?.reason ||
                          errW?.message ||
                          errW ||
                          "Unknown Error",
                        className: "custom-class",
                        duration: 2,
                      });
                    });
                })
                .catch((err: any) => {
                  console.log("err", err);
                  setLoadingCommit(false);
                  message.error({
                    type: "error",
                    content:
                      err?.reason || err?.message || err || "Unknown Error",
                    className: "custom-class",
                    duration: 2,
                  });
                });
            }
          }
        })
        .catch((err: any) => {
          console.log("err", err);
          setLoadingCommit(false);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingCommit(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  }

  const handleClaim = async () => {
    try {
      setIsSendingTx(true);
      setLoadingClaim(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingClaim(false);
        return;
      }

      let _id = objVestingClaim?.id;
      let _poolId = obj?.id;
      let _tgeFlag = objVestingClaim?.tge_flag;
      let _token = objVestingClaim?.token_address;
      let _amount = objVestingClaim?.amount_string;
      let _startTime = objVestingClaim?.start_time;
      let _sig = objVestingClaim?.signature;
      await ContractClaim.vesting(
        _id,
        _poolId,
        _tgeFlag,
        _token,
        _amount,
        _startTime,
        _sig
      )
        .then(async (res: any) => {
          await res
            .wait()
            .then(async (resW: any) => {
              if (resW?.status === 1) {
                let paramsUpdate = {
                  txn: res?.hash,
                };
                setTimeout(async () => {
                  setActionClaim(!actionClaim);
                  setLoadingClaim(false);
                  setIsClaimed(true);
                  getDataCheckRefund();
                  await apiLaunchPad.updateHashClaim(paramsUpdate, _id);
                  getDataPoolEnd();
                  message.success({
                    type: "success",
                    content: "Claimed Successfully",
                    className: "custom-class",
                    duration: 2,
                  });
                }, 1500);
              } else {
                setLoadingClaim(false);
                setIsClaimed(false);
                message.error({
                  type: "error",
                  content: "Claimed Fail, Status Hash Fail",
                  className: "custom-class",
                  duration: 2,
                });
              }
            })
            .catch((errW: any) => {
              console.log("errW", errW);
              setLoadingClaim(false);
              setIsClaimed(false);
              message.error({
                type: "error",
                content:
                  errW?.reason || errW?.message || errW || "Unknown Error",
                className: "custom-class",
                duration: 2,
              });
            });
        })
        .catch((err: any) => {
          setLoadingClaim(false);
          setIsClaimed(false);
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingClaim(false);
      setIsClaimed(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  const handleClaimBonus = async () => {
    try {
      setIsSendingTx(true);
      setLoadingBonus(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingBonus(false);
        return;
      }
      let _id = objBonus?.id;
      let _poolId = objBonus?.pool_id;
      let _token = objBonus?.token_address;
      let _amount = objBonus?.amount_string;
      let _startTime = objBonus?.start_time;
      let _sig = objBonus?.signature;
      await ContractClaim.bonus(_id, _poolId, _token, _amount, _startTime, _sig)
        .then(async (res: any) => {
          await res
            .wait()
            .then(async (resW: any) => {
              if (resW?.status === 1) {
                let paramsUpdate = {
                  txn: res?.hash,
                };
                setLoadingBonus(false);
                await apiLaunchPad.updateHashBonus(paramsUpdate, _id);
                message.success({
                  type: "success",
                  content: "Bonus Claimed Successfully",
                  className: "custom-class",
                  duration: 2,
                });
                getDataClaimBonus();
              } else {
                setLoadingBonus(false);
                message.error({
                  type: "error",
                  content: "Bonus Claimed Fail, Status hash fail",
                  className: "custom-class",
                  duration: 2,
                });
              }
            })
            .catch((errW: any) => {
              setLoadingBonus(false);
              message.error({
                type: "error",
                content:
                  errW?.reason || errW?.message || errW || "Unknown Error",
                className: "custom-class",
                duration: 2,
              });
            });
        })
        .catch((err: any) => {
          setLoadingBonus(false);
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingBonus(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  const handleRefundAll = async () => {
    try {
      setIsSendingTx(true);
      setLoadingRefundAll(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingRefundAll(false);
        return;
      }
      let _id = objRefund?.id;
      let _poolId = objRefund?.pool_id;
      let _token = objRefund?.token_address;
      let _amount = objRefund?.amount_string;
      let _startTime = objRefund?.start_time;
      let _endTime = objRefund?.end_time;
      let _sig = objRefund?.signature;
      await ContractClaim.refund(
        _id,
        _poolId,
        _token,
        _amount,
        _startTime,
        _endTime,
        _sig
      )
        .then(async (res: any) => {
          await res
            .wait()
            .then(async (resW: any) => {
              if (resW?.status === 1) {
                let paramsUpdate = {
                  txn: res?.hash,
                };
                setLoadingRefundAll(false);
                await apiLaunchPad.updateHashRefundAll(paramsUpdate, _id);
                message.success({
                  type: "success",
                  content: "Refunded Successfully",
                  className: "custom-class",
                  duration: 2,
                });
                setActionRf(!actionRf);
                getDataCheckRefund();
              } else {
                setLoadingRefundAll(false);
                message.error({
                  type: "error",
                  content: "Refunded Fail, Status hash fail",
                  className: "custom-class",
                  duration: 2,
                });
              }
            })
            .catch((errW: any) => {
              setLoadingRefundAll(false);
              message.error({
                type: "error",
                content:
                  errW?.reason || errW?.message || errW || "Unknown Error",
                className: "custom-class",
                duration: 2,
              });
            });
        })
        .catch((err: any) => {
          setLoadingRefundAll(false);
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingRefundAll(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  const handleRefundPartical = async () => {
    try {
      setIsSendingTx(true);
      setLoadingRefundPartical(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingRefundPartical(false);
        return;
      }
      let _id = objPartialRefund?.id;
      let _poolId = objPartialRefund?.pool_id;
      let _token = objPartialRefund?.token_address;
      let _amount = objPartialRefund?.amount_string;
      let _startTime = objPartialRefund?.start_time;
      let _endTime = objPartialRefund?.end_time;
      let _sig = objPartialRefund?.signature;
      await ContractClaim.partialRefund(
        _id,
        _poolId,
        _token,
        _amount,
        _startTime,
        _endTime,
        _sig
      )
        .then(async (res: any) => {
          await res
            .wait()
            .then(async (resW: any) => {
              if (resW?.status === 1) {
                let paramsUpdate = {
                  txn: res?.hash,
                };
                setLoadingRefundPartical(false);
                await apiLaunchPad.updateHashRefundPartical(paramsUpdate, _id);
                message.success({
                  type: "success",
                  content: "Refunded Successfully",
                  className: "custom-class",
                  duration: 2,
                });
                setActionRf(!actionRf);
                getDataCheckRefund();
              } else {
                setLoadingRefundPartical(false);
                message.error({
                  type: "error",
                  content: "Refunded Fail, Status hash fail",
                  className: "custom-class",
                  duration: 2,
                });
              }
            })
            .catch((errW: any) => {
              setLoadingRefundPartical(false);
              message.error({
                type: "error",
                content:
                  errW?.reason || errW?.message || errW || "Unknown Error",
                className: "custom-class",
                duration: 2,
              });
            });
        })
        .catch((err: any) => {
          setLoadingRefundPartical(false);
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingRefundPartical(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  const handleClaimChange = async () => {
    try {
      setIsSendingTx(true);
      setLoadingClaimChange(true);
      if (showNetworkWarning) {
        message.error({
          type: "error",
          content: "Please Switch Network",
          className: "custom-class",
          duration: 2,
        });
        setLoadingClaimChange(false);
        return;
      }
      let _id = objVestingClaimChange?.id;
      let _poolId = objVestingClaimChange?.pool_id;
      let _token = objVestingClaimChange?.token_address;
      let _amount = objVestingClaimChange?.amount_string;
      let _startTime = objVestingClaimChange?.start_time;
      let _sig = objVestingClaimChange?.signature;
      await ContractClaim.crf(_id, _poolId, _token, _amount, _startTime, _sig)
        .then(async (res: any) => {
          await res
            .wait()
            .then(async (resW: any) => {
              if (resW?.status === 1) {
                let paramsUpdate = {
                  txn: res?.hash,
                };
                setActionClaimChange(!actionClaimChange);
                setLoadingClaimChange(false);
                setIsClaimedChange(true);
                await apiLaunchPad.updateHashClaimChange(paramsUpdate, _id);
                message.success({
                  type: "success",
                  content: "Claimed Change Successfully",
                  className: "custom-class",
                  duration: 2,
                });
              } else {
                setLoadingClaimChange(false);
                setIsClaimedChange(false);
                message.error({
                  type: "error",
                  content: "Claimed Change Fail, Status Hash Fail",
                  className: "custom-class",
                  duration: 2,
                });
              }
            })
            .catch((errW: any) => {
              console.log("errW", errW);
              setLoadingClaimChange(false);
              setIsClaimedChange(false);
              message.error({
                type: "error",
                content:
                  errW?.reason || errW?.message || errW || "Unknown Error",
                className: "custom-class",
                duration: 2,
              });
            });
        })
        .catch((err: any) => {
          setLoadingClaimChange(false);
          setIsClaimedChange(false);
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
        });
    } catch (error: any) {
      console.log("error", error);
      setLoadingClaimChange(false);
      setIsClaimedChange(false);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
    } finally {
      setIsSendingTx(false);
    }
  };

  const [currentBonusPercent, setBonusPercent]: any = useState(0);

  useEffect(() => {
    const currentRule = obj?.bonus_rules.find(
      (rule: any) =>
        Number(totalCommitUser) >= rule.min &&
        Number(totalCommitUser) <= rule.max
    );
    if (currentRule) {
      setBonusPercent(currentRule);
    } else {
      setBonusPercent(0);
    }
  }, [obj, address, totalCommitUser]);

  const renderBonusRules = (bonusRules: any[]) => {
    return bonusRules.map((item: any) => {
      return (
        <div
          key={item.id}
          className={`item ${
            item.id === currentBonusPercent.id ? "active" : ""
          }`}
        >
          {item.bonus_percent}% <span>BONUS</span>
        </div>
      );
    });
  };

  const { switchChainAsync } = useSwitchChain();
  const switchChainBNB = async () => {
    try {
      await switchChainAsync({
        chainId: launchpadDetail?.token?.chain?.chain_id,
      })
        .then((res: any) => {
          message.success({
            type: "success",
            content: "Switched Chain Successfully",
            className: "custom-class",
            duration: 2,
          });
          return true;
        })
        .catch((err: any) => {
          console.log("err", err);
          message.error({
            type: "error",
            content: err?.reason || err?.message || err || "Unknown Error",
            className: "custom-class",
            duration: 2,
          });
          return false;
        });
    } catch (error: any) {
      console.log("error", error);
      message.error({
        type: "error",
        content: error?.reason || error?.message || error || "Unknown Error",
        className: "custom-class",
        duration: 2,
      });
      return false;
    }
  };
  let sortBonusRule: any = obj?.bonus_rules.sort(
    (a: any, b: any) => a.min - b.min
  );

  //check solana address
  const [modalOpen, setModalOpen] = useState(false);
  const [solanaAddress, setSolanaAddress] = useState("");

  const handleGetSolanaAdress = async () => {
    try {
      const response = await apiLaunchPad.getSolanaAddres(
        address,
        obj.campaign_id.toString()
      );
      if (response?.data && response?.data?.claim_address) {
        setSolanaAddress(response?.data?.claim_address);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleGetSolanaAdress();
  }, []);

  return (
    <>
      <SubmitSolanaModal
        {...{ modalOpen, setModalOpen, address }}
        campaignId={obj.campaign_id}
      />
      <div className="body-round">
        <div className="box-round">
          <div className="box-round-left">
            <div className="box-text20">PRICE PER TOKEN</div>
            <div className="box-text32">
              1 {launchpadDetail?.token?.symbol} = {obj?.price}{" "}
              {launchpadDetail?.currency?.symbol}
            </div>
          </div>
          <div className="box-round-mid" onClick={switchChainBNB}>
            <img src={launchpadDetail?.token?.chain?.logo} alt="" />
            <span>{launchpadDetail?.token?.chain?.name}</span>
          </div>
          <div className="box-round-right">
            <div className="box-text20">{renderTextTime(statusPool)}</div>
            <div className="box-text32">
              <Countdown
                renderer={rendererCountDown1}
                date={curentTime <= startTimeMs ? startTimeMs : endTimeMs}
              />
            </div>
          </div>
        </div>
        <div className="round-row-info">
          <div className="row-info-item">
            <div className="row-info-title">
              Progress: <span>{Number(percent.toFixed(2))}%</span>
            </div>
          </div>

          <div className="row-info-item">
            <div className="row-info-num">
              <span style={{ color: "#0194FF" }}>
                {formatNumber(obj?.total_sold, 8)}/
              </span>
              {formatNumber(obj?.total_raise, 8)}{" "}
              {launchpadDetail?.currency?.symbol}
            </div>
          </div>
        </div>
        <div className="process-ido">
          <div className="bottom">
            <Progress
              percent={Number(percent.toFixed(2))}
              percentPosition={{ align: "center", type: "inner" }}
              size={["100%", 20]}
              strokeColor={{ from: "#3C8CE7", to: "#00EAFF" }}
            />
          </div>
        </div>
        <div className="round-action">
          {statusPool === OPEN ? (
            <>
              <div className="num-buy">
                <div className="max-buy">Min:</div>
                <div className="max-num">
                  {formatNumber(obj?.min_join, 8)}{" "}
                  {launchpadDetail?.currency?.symbol}
                </div>
              </div>
              <div className="num-buy">
                <div className="max-buy">Max:</div>
                <div className="max-num">
                  {formatNumber(obj?.max_join, 8)}{" "}
                  {launchpadDetail?.currency?.symbol}
                </div>
              </div>

              {address ? (
                <>
                  {isWhiteList ? (
                    <>
                      {Number(totalCommitUser) === obj?.max_join ? (
                        <>
                          <div className="wrap-commit">
                            <div className="group-btn-action input-comit">
                              <button className="button-ido-dis btn-claim-active1 btn-detail-disable">
                                Commited
                                <div className="btn-dis-ab active1"></div>
                              </button>
                            </div>
                            <div className="row-info-item custom">
                              <div className="row-info-title">
                                your commited:
                              </div>
                              <div className="row-info-num">
                                {formatNumber(totalCommitUser, 8)}{" "}
                                {launchpadDetail?.currency?.symbol}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="wrap-commit">
                            <div
                              className={`group-btn-action input-comit ${
                                warning || warningMax || warningDecimal
                                  ? "input-comit-new"
                                  : ""
                              }`}
                            >
                              <input
                                value={amountCommitFormat}
                                onChange={handleAmoutCommit}
                                placeholder="0"
                                className="input-action"
                                disabled={loadingApprove || loadingCommit}
                              />
                              <span className="text-warning">{warning}</span>
                              <span className="text-warning">{warningMax}</span>
                              <span className="text-warning">
                                {warningDecimal}
                              </span>

                              {amountCommit &&
                              Number(amountCommit) >= obj?.min_join &&
                              Number(amountCommit) <= obj?.max_join ? (
                                <>
                                  {!isApprove ? (
                                    <>
                                      {loadingApprove ? (
                                        <button className="button-ido-dis btn-claim-active1 btn-detail-disable">
                                          <span className="loader"></span>
                                          <div className="btn-dis-ab active1"></div>
                                        </button>
                                      ) : (
                                        <button
                                          onClick={handleApprove}
                                          className="button-ido-dis btn-claim-active1"
                                        >
                                          approve
                                          <div className="btn-dis-ab active1"></div>
                                        </button>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {loadingCommit ? (
                                        <button className="button-ido-dis btn-claim-active1 btn-detail-disable">
                                          <span className="loader"></span>
                                          <div className="btn-dis-ab active1"></div>
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() => {
                                            if (
                                              launchpadDetail?.token?.chain
                                                ?.type !==
                                                launchpadDetail?.currency?.chain
                                                  ?.type &&
                                              launchpadDetail?.token?.chain
                                                ?.type === "SOL" &&
                                              !solanaAddress
                                            ) {
                                              setModalOpen(true);
                                            } else {
                                              handleCommit();
                                            }
                                          }}
                                          className="button-ido-dis btn-claim-active1"
                                        >
                                          commit
                                          <div className="btn-dis-ab active1"></div>
                                        </button>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <button className="button-ido-dis btn-claim-active1 btn-detail-disable">
                                    Commit
                                    <div className="btn-dis-ab active1"></div>
                                  </button>
                                </>
                              )}
                            </div>
                            <div className="row-info-item custom">
                              <div className="row-info-title">
                                your commited:
                              </div>
                              <div className="row-info-num">
                                {formatNumber(totalCommitUser, 8)}{" "}
                                {launchpadDetail?.currency?.symbol}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div className="group-btn-action">
                      <button className="button-ido-dis">
                        you're not whitelisted
                        <div className="btn-dis-ab"></div>
                      </button>
                    </div>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {address ? (
                <>
                  {statusPool === END && !isWhiteList ? (
                    <>
                      <div className="num-buy"></div>
                      <div className="num-buy"></div>
                      <div className="group-btn-action">
                        <button className="button-ido-dis">
                          you're not whitelisted
                          <div className="btn-dis-ab"></div>
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      {statusPool === END &&
                      isWhiteList &&
                      Number(totalCommitUser) === 0 ? (
                        <>
                          <div className="num-buy"></div>
                          <div className="num-buy"></div>
                          <div className="group-btn-action">
                            <button className="button-ido-dis">
                              you're not committed
                              <div className="btn-dis-ab"></div>
                            </button>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          )}
        </div>

        {obj?.is_bonus && obj?.bonus_rules.length > 0 ? (
          <>
            <div className="row-bonus">
              <div className="bonus-detail">
                <img src="/images/detail-ido/info.png" alt="" />
                <span>BONUS DETAILS</span>
              </div>
              <div className="box-bonus">
                <div className="top-box-bonus">
                  <div className="text-left-bonus">Bonus milestones</div>
                  <div className="text-right-bonus">
                    Current bonus{" "}
                    <span>{currentBonusPercent.bonus_percent}%</span>
                  </div>
                </div>
                <div className="mid-box-bonus">
                  <div className="text-min-max">
                    <div className="item-min-max">Min</div>
                    <div className="item-min-max">Max</div>
                  </div>
                  <div className="num-min-max">
                    <div className="item-num-min-max">
                      {sortBonusRule[0]?.min}
                    </div>
                    {sortBonusRule.map((item: any) => (
                      <>
                        <div className="item-num-min-max">
                          {formatNumber(item?.max, 8)}
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="bonus-project-line">
                    {renderBonusRules(sortBonusRule)}
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}

        {statusPool === END && isWhiteList && Number(totalCommitUser) !== 0 ? (
          <>
            <div className="round-end">
              <div className="round-end-left">
                <div className="round-end-title">CLAIM TOKEN</div>
                <div className="row-round-end">
                  <>
                    {objVestingClaimChange?.signature &&
                    JSON.stringify(objVestingClaimChange) !==
                      JSON.stringify({}) &&
                    curentTime >= objVestingClaimChange?.start_time * 1000 ? (
                      <>
                        <div className="row-end-item item-claim-change">
                          <div className="row-end-item-left">
                            Remaining Fund
                          </div>
                          <div className="row-end-item-right">
                            {/* {isClaimedChange ? } */}
                            {amountClaimedChange > 0 ? (
                              <div className="group-btn-action claim-change">
                                <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                  Claimed{" "}
                                  {formatNumber(
                                    objVestingClaimChange?.amount,
                                    8
                                  )}{" "}
                                  {symbolRF}
                                  <div className="btn-dis-ab active1"></div>
                                </button>
                              </div>
                            ) : (
                              <div className="group-btn-action claim-change">
                                {loadingClaimChange ? (
                                  <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                    <span className="loader"></span>
                                    <div className="btn-dis-ab active1"></div>
                                  </button>
                                ) : (
                                  <>
                                    <button
                                      onClick={handleClaimChange}
                                      className="button-ido-dis btn-claim-active1"
                                    >
                                      Claim{" "}
                                      {formatNumber(
                                        objVestingClaimChange?.amount,
                                        8
                                      )}{" "}
                                      {symbolRF}
                                      <div className="btn-dis-ab active1"></div>
                                    </button>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <div className="row-end-item">
                      <div className="row-end-item-left">Vesting Schedule</div>
                      <div className="row-end-item-right yellow">
                        {launchpadDetail?.vesting_schedule
                          ? launchpadDetail?.vesting_schedule
                          : "TBA"}
                      </div>
                    </div>
                    {objAllocation?.token_amount ? (
                      <div className="row-end-item">
                        <div className="row-end-item-left">
                          Total Bought Token
                        </div>
                        <div className="row-end-item-right">
                          {formatNumber(objAllocation?.token_amount, 8)}{" "}
                          {launchpadDetail?.token?.symbol}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="row-end-item">
                      <div className="row-end-item-left">Total Bought</div>
                      <div className="row-end-item-right">
                        {formatNumber(
                          objAllocation?.allocation_amount || totalCommitUser,
                          8
                        )}{" "}
                        {launchpadDetail?.currency?.symbol}
                      </div>
                    </div>

                    {Number(amountClaimed) > 0 ? (
                      <div className="row-end-item">
                        <div className="row-end-item-left">Total Claimed</div>
                        <div className="row-end-item-right">
                          {formatNumber(amountClaimed, 8)}{" "}
                          {launchpadDetail?.token?.symbol}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {Number(amountClaimedBonus) > 0 ? (
                      <div className="row-end-item">
                        <div className="row-end-item-left">
                          Total Claimed Bonus
                        </div>
                        <div className="row-end-item-right">
                          {formatNumber(amountClaimedBonus, 8)}{" "}
                          {launchpadDetail?.token?.symbol}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {Number(amountRefundPartial) > 0 ? (
                      <div className="row-end-item">
                        <div className="row-end-item-left">
                          Total Refunded Partial
                        </div>
                        <div className="row-end-item-right">
                          {formatNumber(amountRefundPartial, 8)} {symbolRF}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {Number(amountRefundAll) > 0 ? (
                      <div className="row-end-item">
                        <div className="row-end-item-left">
                          Total Refunded Full
                        </div>
                        <div className="row-end-item-right">
                          {formatNumber(amountRefundAll, 8)} {symbolRF}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>

                  {Number(totalCommitUser) === 0 ? (
                    <>
                      <div className="group-btn-action">
                        <button className="button-ido-dis btn-claim-active1 btn-detail-disable disable-new">
                          You're Not Commit
                          <div className="btn-dis-ab active1"></div>
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* start claim */}
                      {curentTime >= objVestingClaim?.start_time * 1000 &&
                      objVestingClaim?.amount > 0 ? (
                        <>
                          {isClaimed ? (
                            <div className="group-btn-action">
                              <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                Claim
                                <div className="btn-dis-ab active1"></div>
                              </button>
                            </div>
                          ) : (
                            <>
                              {Number(amountClaimed) > 0 &&
                              Number(amountRefundPartial) > 0 ? (
                                ""
                              ) : (
                                <>
                                  {loadingClaim ? (
                                    <>
                                      <div className="group-btn-action">
                                        <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                          <span className="loader"></span>
                                          <div className="btn-dis-ab active1"></div>
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {userRefundAmount > 0 ? (
                                        <>{""}</>
                                      ) : (
                                        <>
                                          <div className="group-btn-action">
                                            <button
                                              onClick={handleClaim}
                                              className="button-ido-dis btn-claim-active1"
                                            >
                                              Claim token
                                              <div className="btn-dis-ab active1"></div>
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                      {obj?.is_bonus &&
                      curentTime >= objBonus?.start_time * 1000 ? (
                        <>
                          {loadingBonus ? (
                            <>
                              <div className="group-btn-action">
                                <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                  <span className="loader"></span>
                                  <div className="btn-dis-ab active1"></div>
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              {isClaimedBonus > 0 ? (
                                <>
                                  <div className="group-btn-action">
                                    <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                      Claimed Bonus
                                      <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="group-btn-action">
                                    <button
                                      className="button-ido-dis btn-bonus-active1"
                                      onClick={handleClaimBonus}
                                    >
                                      Bonus
                                      <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                    </button>
                                  </div>
                                </>
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>{""}</>
                      )}
                      <div className="group-refund">
                        {obj?.is_partial_refund &&
                        curentTime >= objPartialRefund?.start_time * 1000 &&
                        curentTime <= objPartialRefund?.end_time * 1000 &&
                        objPartialRefund?.signature ? (
                          <>
                            {userRefundAmount === 0 &&
                            userPartialRefundAmount === 0 ? (
                              <>
                                {loadingRefundPartical ? (
                                  <>
                                    <button className="button-ido-dis btn-rf-active1 btn-rfa">
                                      <span className="loader"></span>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="button-ido-dis btn-rf-active1 btn-rfr"
                                      onClick={handleRefundPartical}
                                    >
                                      REFUND THE REST
                                      <div className="coundd-down-rf">
                                        <Countdown
                                          renderer={rendererCountDown}
                                          date={
                                            objPartialRefund?.end_time * 1000
                                          }
                                        />
                                      </div>
                                      <div className="btn-dis-ab btn-dis-ab-rf active1"></div>
                                    </button>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {userPartialRefundAmount > 0 ? (
                                  <>
                                    {isCheckVesting > 1 ? (
                                      <>{""}</>
                                    ) : (
                                      <>
                                        <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                          REFUNDED THE REST
                                          <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                        </button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>{""}</>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {obj?.is_partial_refund &&
                            curentTime > objPartialRefund?.end_time * 1000 &&
                            objPartialRefund?.signature ? (
                              <>
                                {userPartialRefundAmount > 0 ? (
                                  <>
                                    {isCheckVesting > 1 ? (
                                      <>{""}</>
                                    ) : (
                                      <>
                                        <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                          REFUNDED THE REST
                                          <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                        </button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>{""}</>
                                )}
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                        {userClaimAmount > 0 ? (
                          <>{""}</>
                        ) : (
                          <>
                            {obj?.is_refund &&
                            curentTime >= objRefund?.start_time * 1000 &&
                            curentTime <= objRefund?.end_time * 1000 &&
                            objRefund?.signature ? (
                              <>
                                {userClaimAmount === 0 &&
                                userRefundAmount === 0 &&
                                userPartialRefundAmount === 0 ? (
                                  <>
                                    {loadingRefundAll ? (
                                      <>
                                        <button className="button-ido-dis btn-rf-active1 btn-rfa">
                                          <span className="loader"></span>
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        <button
                                          className="button-ido-dis btn-rf-active1 btn-rfa"
                                          onClick={handleRefundAll}
                                        >
                                          REFUND ALL
                                          <div className="coundd-down-rf">
                                            <Countdown
                                              renderer={rendererCountDown}
                                              date={objRefund?.end_time * 1000}
                                            />
                                          </div>
                                          <div className="btn-dis-ab btn-dis-ab-rf active1"></div>
                                        </button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {userRefundAmount > 0 ? (
                                      <>
                                        <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                          REFUNDED ALL
                                          <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                        </button>
                                      </>
                                    ) : (
                                      <>{""}</>
                                    )}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {obj?.is_refund &&
                                objRefund?.signature &&
                                curentTime >= objRefund?.end_time * 1000 ? (
                                  <>
                                    {userRefundAmount > 0 ? (
                                      <>
                                        <button className="button-ido-dis btn-claim-active1  btn-detail-disable disable-new">
                                          REFUNDED ALL
                                          <div className="btn-dis-ab btn-dis-ab-bonus active1"></div>
                                        </button>
                                      </>
                                    ) : (
                                      <>{""}</>
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="round-end-right">
                <div className="round-end-title">SCHEDULE</div>
                <div className="table-schedule">
                  <table cellSpacing={0}>
                    <tr>
                      <th className="header-tb">date (UTC)</th>
                      <th className="header-tb">%</th>
                      <th className="header-tb">Amount</th>
                      <th className="header-tb">Status</th>
                    </tr>
                    {objSchedule?.length > 0 ? (
                      <>
                        {objSchedule.map((item: any, index: any) => (
                          <tr className="row-tr">
                            <td colSpan={0} className="row-tb">
                              {formatDateSchedule(item?.start_time)}
                            </td>
                            <td colSpan={0} className="row-tb">
                              {formatNumber(item?.schedule?.vesting_percent, 8)}
                            </td>
                            <td className="row-tb">
                              {formatNumber(item?.vesting_amount, 8)}
                            </td>
                            <td className="row-tb">
                              {renderStatus(item?.status)}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        {obj?.schedules?.length > 0 ? (
                          <>
                            {obj?.schedules.map((item: any, index: any) => (
                              <tr className="row-tr">
                                <td colSpan={0} className="row-tb">
                                  {formatDateSchedule1(item?.start_time)}
                                </td>
                                <td colSpan={0} className="row-tb">
                                  {formatNumber(item?.vesting_percent, 8)}
                                </td>
                                <td className="row-tb">
                                  {item?.vesting_amount || "---"}{" "}
                                </td>
                                <td className="row-tb">
                                  <span className="status-new">---</span>
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr className="row-tr empty-row">
                            <td className="row-tb empty-table" colSpan={4}>
                              <img src="/images/nodata.png" alt="" />
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      <img
        className="box-affter"
        src="/images/detail-ido/box-affter.png"
        alt=""
      />
    </>
  );
};

const Action = (props: any) => {
  let startTime = props?.startTime;
  let showNetworkWarning = props.showNetworkWarning;
  const [activeKeys, setActiveKeys] = useState(["1"]);
  const { address }: any = useAccount();
  const [listWl, setListWl]: any = useState([]);
  const [itemArr, setItemArr]: any = useState([]);

  const handleCollapseChange = (key: any) => {
    setActiveKeys(key);
  };

  const getWlUser = async () => {
    try {
      let res = await apiLaunchPad.checkWhiteList(
        props.launchpadDetail?.id,
        address
      );
      if (res.data.code === 200) {
        setListWl(res?.data?.data);
      } else {
        setListWl([]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getDataArray = () => {
    let itemArrTemp: any = [];
    let check: any;
    props?.launchpadDetail?.pools?.sort((a: any, b: any) => a.id - b.id);
    props?.launchpadDetail?.pools?.forEach(async (element: any, index: any) => {
      if (!element?.is_whitelist) {
        check = true;
      } else if (listWl?.some((obj: any) => obj.pool_id === element?.id)) {
        check = true;
      } else {
        check = false;
      }
      let objTemp = {
        key: index + 1,
        label: (
          <ItemHeaderRound
            name={element?.type}
            status={check}
            text={
              Number(activeKeys[0]) === index + 1 ? "show less" : "show more"
            }
          />
        ),
        children: (
          <ItemContentRound
            obj={element}
            launchpadDetail={props?.launchpadDetail}
            isWhiteList={check}
            onSendData={props?.onSendData}
            onSendData1={props?.onSendData1}
            showNetworkWarning={showNetworkWarning}
          />
        ),
        className: "col-item",
      };
      itemArrTemp.push(objTemp);
    });

    setItemArr(itemArrTemp);
  };

  useEffect(() => {
    getDataArray();
  }, [props, address, listWl]);

  useEffect(() => {
    getWlUser();
  }, [props, address]);

  return (
    <>
      <div className="group-action">
        {props?.launchpadDetail?.pools?.length === 0 ? (
          <>
            <div className="count-down-coming">
              <div className="start-in-detail">Starts In</div>
              {startTime ? (
                <Countdown renderer={rendererCountDown} date={startTime} />
              ) : (
                "TBA"
              )}
            </div>
          </>
        ) : (
          <>
            <div className="project-text">
              <img src="/images/detail-ido/project-action.svg" alt="" />
            </div>
            <div className="list-round">
              <Collapse
                bordered={false}
                expandIcon={({ isActive }) => (
                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                )}
                items={itemArr}
                activeKey={activeKeys}
                onChange={handleCollapseChange}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Action;
